import { Fragment } from 'react'
import './Timeline.scss'
interface ToggleButtonProps {
    disabled?: boolean
    onToggle: () => void
    active: boolean
    hideToggle?: boolean
    children?: React.ReactNode
}


/**
 * TimelineToggleButton component
 *
 * @param {ToggleButtonProps} props - The props for the TimelineToggleButton component
 * @param {boolean} props.disabled - Whether the button is disabled or not
 * @param {boolean} props.active - Whether the button is active or not
 * @param {boolean} props.hideToggle - Whether the toggle button should be hidden or not
 * @param {ReactNode} props.children - The children of the button, if any
 * @param {() => void} props.onToggle - The function to be called when the button is clicked
 *
 * The TimelineToggleButton component is used to toggle the timeline. It can be disabled, active, or hidden.
 */
const TimelineToggleButton: React.FC<ToggleButtonProps> = ({ children, onToggle, active, disabled, hideToggle }) => {
    if (hideToggle) return null
    return (
        <button
            className={`timeline__toggle__button ${active && 'active'}`}
            disabled={disabled}
            onClick={onToggle}
            aria-expanded={!!active}
            aria-label={active ? 'Collapse timeline' : 'Expand timeline'}
        >
            {children && children}
            {!children &&
                <Fragment>
                    <svg xmlns="http://www.w3.org/2000/svg" width="62" height="12" viewBox="0 0 62 12" fill="none">
                        <foreignObject x="-40" y="-40" width="142" height="92"><div style={{ backdropFilter: 'blur(20px)', clipPath: 'url(#bgblur_0_31342_199285_clip_path)', height: '100%', width: '100%' }}></div></foreignObject><path data-figma-bg-blur-radius="40" d="M8.80062 1.43926C9.56059 0.527291 10.6864 0 11.8735 0H50.1265C51.3136 0 52.4394 0.527292 53.1994 1.43926L62 12H0L8.80062 1.43926Z" fill="rgba(9, 9, 9, 0.75)" fillOpacity="0.5" />
                        <defs>
                            <clipPath id="bgblur_0_31342_199285_clip_path" transform="translate(40 40)"><path d="M8.80062 1.43926C9.56059 0.527291 10.6864 0 11.8735 0H50.1265C51.3136 0 52.4394 0.527292 53.1994 1.43926L62 12H0L8.80062 1.43926Z" />
                            </clipPath></defs>
                    </svg>
                    <div className='toggle__icon'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <g opacity="0.6" clipPath="url(#clip0_31342_199286)">
                                <path d="M7.5 1L4.25 3.78571L1 1" stroke="#F0F0F0" strokeWidth="0.577778" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M7.5 3.78516L4.25 6.57087L1 3.78516" stroke="#F0F0F0" strokeWidth="0.577778" strokeMiterlimit="16" strokeLinecap="round" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_31342_199286">
                                    <rect width="8" height="8" fill="white" transform="matrix(-4.37114e-08 1 1 4.37114e-08 3.4969e-07 0)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </Fragment>
            }
        </button>
    )
}

export default TimelineToggleButton